import { useState } from 'react';

function useDroppable(onDrop) {
  var _useState = useState(false),
    isDraggingOver = _useState[0],
    setIsDraggingOver = _useState[1];
  var handleDragOver = function handleDragOver(event) {
    event.preventDefault(); // Allows drop
    // onDragOver runs more often than onDragEnter
    // but is necessary since onDragLeave runs when you enter children elements
    setIsDraggingOver(true);
  };
  var handleDrop = function handleDrop(event) {
    event.preventDefault();
    setIsDraggingOver(false);
    var id = event.dataTransfer.getData('text/plain');
    setTimeout(function () {
      // In case the dragged element is removed instantly, make sure the "onDragEnd" event runs first
      // This ensures that `isDragging` in `useDraggable` is updated to `false` when dropping the item
      onDrop(id);
    }, 1);
  };
  var handleDragLeave = function handleDragLeave() {
    setIsDraggingOver(false);
  };
  return {
    isDraggingOver: isDraggingOver,
    droppableProps: {
      onDragOver: handleDragOver,
      onDrop: handleDrop,
      onDragLeave: handleDragLeave
    }
  };
}

export { useDroppable };
